import {
  RECENT_ORG_IDS,
  SELECTED_ORG_ID,
  SELECTED_ORG_NAME,
} from '@/configs/storageKeys';

const MAX_RECENT_ORGS = 10;

export function clearSelectedOrganisation() {
  window.localStorage.removeItem(SELECTED_ORG_ID);
  window.localStorage.removeItem(SELECTED_ORG_NAME);
  window.sessionStorage.removeItem(SELECTED_ORG_ID);
  window.sessionStorage.removeItem(SELECTED_ORG_NAME);
}

/** Returns up to 10 organisation IDs, most recently viewed first. */
export function getRecentOrganisationIds(): number[] {
  try {
    const raw = window.localStorage.getItem(RECENT_ORG_IDS);
    if (!raw) return [];
    return raw
      .split(',')
      .map((s) => parseInt(s.trim(), 10))
      .filter((n) => Number.isFinite(n))
      .slice(0, MAX_RECENT_ORGS);
  } catch {
    return [];
  }
}

/** Prepend an org ID to recent list (dedupe, keep max 10). */
function pushRecentOrganisationId(orgId: number): void {
  const recent = getRecentOrganisationIds();
  const next = [orgId, ...recent.filter((id) => id !== orgId)].slice(
    0,
    MAX_RECENT_ORGS,
  );
  window.localStorage.setItem(RECENT_ORG_IDS, next.join(','));
}

export function storeSelectedOrganisation(orgId: number, orgName: string) {
  // used for users mavigating from home to dashboard to load the last selected org
  window.localStorage.setItem(SELECTED_ORG_ID, String(orgId));
  window.localStorage.setItem(SELECTED_ORG_NAME, orgName);

  // used to select the org inside the current tab
  window.sessionStorage.setItem(SELECTED_ORG_ID, String(orgId));
  window.sessionStorage.setItem(SELECTED_ORG_NAME, orgName);

  pushRecentOrganisationId(orgId);

  // dispatch for current tab only
  window.dispatchEvent(
    new CustomEvent('localStorageChange', {
      detail: { key: 'selectedOrganisationName', newValue: orgName },
    }),
  );
}
